import { observer } from 'mobx-react-lite'
import type { FiltersBuilderViewModel } from '@/features/legends/filters/FiltersBuilderViewModel'
import { FiltersBuilder } from '@/features/legends/filters/components/FiltersBuilder'
import { FilterCardContainer } from '@/features/legends/filters/components/FilterCard/FilterCardContainer'

export interface FiltersBuilderContainerProps {
  vm: FiltersBuilderViewModel
  isDisabled?: boolean
  emptyText?: string | null
  /**
   * Shown between filters, like "AND".
   */
  childLabel?: string
  /**
   * The filters get `${testId}-filter-${index}`.
   */
  testId?: string
}

export const FiltersBuilderContainer = observer(
  function FiltersBuilderContainer({
    vm,
    isDisabled: isDisabledProp,
    emptyText,
    childLabel,
    testId,
  }: FiltersBuilderContainerProps) {
    const isDisabled = vm.isEditingDisabled || isDisabledProp
    return (
      <FiltersBuilder
        isEmpty={vm.isEmpty}
        emptyText={emptyText}
        childLabel={childLabel}
        filterTypes={vm.availableFilterTypes}
        onAdd={vm.addFilter}
        isDisabled={isDisabled}
        testId={testId}
      >
        {vm.filters.map((filterVm, index) => (
          <FilterCardContainer
            key={filterVm.cid}
            vm={filterVm}
            isOnRail
            isDisabled={isDisabled}
            onRemove={() => vm.removeFilter(filterVm)}
            testId={testId && `${testId}-filter-${index}`}
          />
        ))}
      </FiltersBuilder>
    )
  },
)
